import {useState} from 'react';
import {Route, Routes} from 'react-router-dom';

import {default as Case} from './components/user/libcase/Case';

import {default as UserNavbar} from './components/user/Navbar';
import {default as UserCases} from './components/user/cases/Cases';
import {default as UserMicroservices} from './components/user/microservices/Microservices';
import {default as AdminNavbar} from './components/admin/Navbar';
import {default as AdminUsers} from './components/admin/users/Users';
import {default as AdminMicroservices} from './components/admin/microservices/Microservices';
import {default as GroupAdminNavbar} from './components/group_admin/Navbar';
import {default as GroupAdminUsers} from './components/group_admin/users/Users';
import {default as GroupAdminMicroservices} from './components/group_admin/microservices/Microservices';
import {default as SavedApiResponse} from './components/user/savedApiResponse/SavedApiResponse';
import Unauthorized from './base_components/Unauthorized';
import PageNotFound from './base_components/PageNotFound';

import styles from './styles/App.module.scss';

function App() {
  const [caseChanges, setCaseChanges] = useState(false);

  return (
    <div className={styles.app}>
      <Routes>
        <Route path='/' element={<UserNavbar caseChanges={caseChanges}/>}>
          <Route index element={<UserCases/>}/>
          <Route path='case/:caseName' element={<Case caseChanges={caseChanges} setCaseChanges={setCaseChanges}/>}/>
          <Route path='microservices' element={<UserMicroservices/>}/>
        </Route>

        <Route path='/group-admin' element={<GroupAdminNavbar/>}>
          <Route index element={<GroupAdminUsers/>}/>
          <Route path='microservices' element={<GroupAdminMicroservices/>}/>
        </Route>

        <Route path='/admin' element={<AdminNavbar/>}>
          <Route index element={<AdminUsers/>}/>
          <Route path='microservices' element={<AdminMicroservices/>}/>
        </Route>

        <Route path='/unauthorized' element={<Unauthorized/>}/>

        <Route path='/r/:refId' element={<SavedApiResponse/>}/>

        <Route path='*' element={<PageNotFound/>}/>
      </Routes>
    </div>
  );
}

export default App;